// SEARCH HEADERS
$(".icon-search").click(function () {
  $(".close-search").addClass("show");
  $(".modal_search").addClass("show_search");
  $(".icon-search").find("#form-search-icon").addClass("show");
});
$(".close-search").click(function () {
  $(".close-search").removeClass("show");
  $(".modal_search").removeClass("show_search");
  $("#form-search-icon").removeClass("show");
});
$(".modal_search").click(function () {
  $(".close-search").removeClass("show");
  $(".modal_search").removeClass("show_search");
  $(".icon-search").find("#form-search-icon").removeClass("show");
});

// JS advanced
$(document).ready(function() {
  if ($(".accordion")) {
    $(".accordion").on("click", function () {
      $(this).parent().toggleClass("active");
      $(this).toggleClass("active");
      $(this).next().slideToggle(200);
    });
  }
});